import { apiEndpointUrl, xApiKey } from '@/env'
import { GenericError, NotFoundError, handleNetworkResponse } from '@/lib/error'

export interface AttachmentUploadUrlResponse {
  id: string
  presignedPutUrl: string
  url: string
  contentType: string
  expiresInSeconds: number
}

export interface UploadAttachmentRequest {
  contentType: string
}

export function getAttachmentUploadUrl(
  questionnaireId: string,
  authToken: string,
  file: File
): Promise<AttachmentUploadUrlResponse> {
  const body: UploadAttachmentRequest = {
    contentType: file.type
  }
  return fetch(
    `${apiEndpointUrl}/v1/questionnaire/${questionnaireId}/attachment`,
    {
      method: 'post',
      headers: {
        'x-api-key': xApiKey,
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
  )
    .then(handleNetworkResponse)
    .then(res => res.json())
    .catch((e: unknown) => {
      if (e instanceof NotFoundError) throw e
      throw new GenericError()
    })
}
